import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, Users, ChevronDown, ChevronUp, ArrowDownAZ, BookCopy, CalendarRange, TicketPercent, IndianRupee, Tv, MailQuestion, CircleUserRound, Plus, Calendar, QrCode, Ticket, MessageCircle, UserRound, UsersRound, Quote } from 'lucide-react';

const MenuItem = ({ icon: Icon, title, to, subItems }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (subItems) {
    return (
      <div>
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="w-full flex items-center py-2.5 px-4 rounded transition duration-200 hover:bg-gray-700 hover:text-white"
        >
          <Icon className="inline-block mr-2" size={20} />
          {title}
          {isOpen ? (
            <ChevronUp className="ml-auto" size={16} />
          ) : (
            <ChevronDown className="ml-auto" size={16} />
          )}
        </button>
        {isOpen && (
          <div className="ml-6">
            {subItems.map((item, index) => (
              <Link
                key={index}
                to={item.to}
                className="block py-2 px-4 rounded transition duration-200 hover:bg-gray-700 hover:text-white"
              >
                {item.title}
              </Link>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <Link
      to={to}
      className="block py-2.5 px-4 rounded transition duration-200 hover:bg-gray-700 hover:text-white"
    >
      <Icon className="inline-block mr-2" size={20} /> {title}
    </Link>
  );
};

const Sidebar = ({ isOpen, toggleSidebar }) => {

  const path = window?.location?.pathname;

  return (
    <>
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden ${isOpen ? 'block' : 'hidden'
          }`}
        onClick={toggleSidebar}
      ></div>
      <aside
        className={`bg-gray-800 text-white w-64 space-y-6 py-7 px-2 absolute inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'
          } md:relative md:translate-x-0 transition duration-200 ease-in-out z-30 overflow-y-auto`}
      >
        <div className="flex items-center justify-between px-4">
          <span className="text-2xl font-extrabold">AdminDash</span>
          <button onClick={toggleSidebar} className="md:hidden">
            <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <nav>

          <MenuItem icon={Tv} title="Classes" to="/classes" />
          <MenuItem icon={TicketPercent} title="Coupons" to="/coupons" />
          <MenuItem icon={BookCopy} title="Courses" to="/courses" />
          <MenuItem icon={Home} title="Dashboard" to="/" />
          <MenuItem icon={CalendarRange} title="Events" to="/events" />
          <MenuItem icon={CircleUserRound} title="Instructors" to="/instructors" />
          <MenuItem
            icon={ArrowDownAZ}
            title="Leads"
            subItems={[
              { title: "Bengali Free", to: "/bng-free-leads" },
              { title: "Bng Money", to: "/bng-money-leads" },
              { title: "BLS Bengali(Free)", to: "/bls-bengali-free-leads" },
              { title: "BLS Bng(Paid)", to: "/bls-bng-paid-leads" },
              { title: "BLS Eng(Paid)", to: "/bls-eng-paid-leads" },
              { title: "BLS Eng(Free)", to: "/bls-eng-free-leads" },
              { title: "BLS Eng (Free) Old", to: "/old-eng-bls-free-leads" },
              { title: "Bls Eng Brochure", to: "/bls-eng-brochure-leads" },
              { title: "Blsgraduate", to: "/bls-graduate-leads" },
              { title: "Consultancy Leads", to: "/consultancy-leads" },
              { title: "Chakra Healing", to: "/chakra-healing" },
              { title: "Chakra Quiz", to: "/chakra-quiz" },
              { title: "Chronic Healing", to: "/chronic-healing-leads" },
              { title: "Daily Meditation", to: "/daily-meditation-leads" },
              { title: "Eq", to: "/eqleads" },
              { title: "Eng Emotion(paid)", to: "/eng-emotion-leads" },
              { title: "Eng Money", to: "/eng-money-leads" },
              { title: "Free Affirmation", to: "/free-affirmation-leads" },
              { title: "Free Bie", to: "/free-bie" },
               { title: "Free Meditation", to: "/free-meditation-leads" },
              { title: "Healing and Problem Solving", to: "/healing-problem-solving" },
              { title: "Healing Quiz", to: "/healing-quiz" },
              { title: "Health Bng(Paid)", to: "/health-bng-paid-leads" },
              { title: "Intro Masterclass", to: "/intro-masterclass-leads" },
              { title: "Law of Attraction", to: "/law-of-attraction-leads" },
              { title: "Lions day", to: "/lions-day-leads" },
              { title: "Live Guided Healing", to: "/live-guided-healing-leads" },
              { title: "Manifestation", to: "/manifestation-leads" },
              { title: "Mind Body Healing", to: "/mind-body-healing-leads" },
              { title: "Money Beng New", to: "/money-bengali-new-leads" },
              { title: "New Money Manifest(Eng)", to: "/new-money-manifestation-eng-leads" },
              { title: "Parenting", to: "/parenting-leads" },
              { title: "Payment Bonus", to: "/paymentbonus-download-leads" },
              { title: "Shadow Work", to: "/shadow-work" },
              { title: "Silva Durgapur", to: "/silva-in-durgapur" },
              { title: "Sls Bng Intro", to: "/sls-bng-intro-leads" },
              { title: "SLS Eng(Paid)", to: "/sls-eng-paid-leads" },
              { title: "Stress", to: "/stress-management-leads" },
              { title: "Stress Intro", to: "/stress-intro-leads" },
              { title: "Stress Bng (Free)", to: "/stress-beng-free-leads" },
              { title: "Stress Bng(Paid)", to: "/stress-bng-paid-leads" },
              { title: "Subconscious Quiz Lead", to: "/subconscious-quiz-leads" },
              { title: "Vision Board", to: "/vision-boards" },
              { title: "WomensDay Eng", to: "/womensday-eng-leads" },
              { title: "Womensday Beng", to: "/womensday-beng-leads" },
            ]}
          />

          <MenuItem icon={IndianRupee} title="Orders" to="/orders" />
          <MenuItem icon={MailQuestion} title="Queries" to="/queries" />
          <MenuItem icon={Ticket} title="Tickets" subItems={[
            { title: "Tickets", to: "/tickets" },
            { title: "Create Ticket", to: "/create-ticket" },
            { title: "Scan Tickets", to: "/scan-ticket" },
          ]} />
          <MenuItem icon={MessageCircle} title="Testimonials" to="/testimonials" />
          {/* <MenuItem icon={QrCode} title="Scan Ticket" to="/scan-ticket" /> */}
          {/* <MenuItem icon={Calendar} title="Upcoming Masterclasses" to="/upcoming-masterclasses" /> */}
          <MenuItem icon={Calendar} title="Upcoming Workshops" to="/upcoming-workshops" />

          <MenuItem icon={Users} title="Users" to="/users" />
          <MenuItem icon={UsersRound} title="Goa Users" to="/goa-users" />
          <MenuItem icon={Quote} title="Goa Users Feedbacks" to="/goa-users-feedbacks" />
          

        </nav>
      </aside>
    </>
  );
};

export default Sidebar;

